import React, { useMemo } from 'react'

import Avatar from '@/components/WorkQueuesContent/components/avatar'
import { dealTeams } from '@/constants/dealTeams'
import { getColor } from '@/key-components/utils/KeyColors'
import { useGetDealTeamsByApplicationQuery } from '@/services/application'
import { useGetLoggedUserQuery } from '@/services/user'
import { UserData } from '@/types/unlock'
import { systemUsers } from '@/utils/user'
import { getUserGroup } from '@/utils/userGroups'
import { useCurrentApplication } from '@/graphql/services/application'

interface UserAvatar {
  userData?: UserData
}

export default function UserAvatar({ userData }: UserAvatar) {
  const { data: application } = useCurrentApplication()

  const { data: applicationDealTeams } = useGetDealTeamsByApplicationQuery(application?.id, {
    skip: !application,
  })

  const { data: loggedUser } = useGetLoggedUserQuery()

  const user = userData ? userData?.user : loggedUser

  const avatarColor = useMemo(() => {
    if (!user) return

    if (user?.groups?.length === 0) {
      return getColor('black')
    }

    if (systemUsers.includes(user?.email)) {
      return getColor('blue', 'l4')
    }

    const userGroup = user?.groups[0]?.name

    if (applicationDealTeams) {
      const userDealTeam = applicationDealTeams.results.filter((dt) => dt.user === user?.id)

      if (userDealTeam.length > 0) {
        return dealTeams[userDealTeam[0].type].color
      }
    }

    return dealTeams[userGroup]?.color ?? getUserGroup(user)?.color ?? '#000'
  }, [user, applicationDealTeams, application])

  return (
    <>
      {user && (
        <Avatar
          user={user}
          color={avatarColor}
        />
      )}
    </>
  )
}
